import { FC } from "react";
import { Box } from "@mui/material";
import { AgentsTree } from "../../components/agents/agents_tree/AgentsTree";

export const DebugPage: FC = () => {
    return <Box height={'100%'} width={'100%'} display={'flex'}>
        <Box flexGrow={1}/>
        <AgentsTree/>
    </Box>
}